const attentionsTabHomeIds = {
  APPOINTMENT_TAB: 1,
  INTERVENTION_TAB: 2
};

export {
  attentionsTabHomeIds
};
